import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RoadMapEndpoint, Url } from "../../Type/BaseUrl";

const RoadMapService = createApi({
	reducerPath: "RoadMapService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			roadContent: builder.query({
				query: (name) => {
					return {
						url: RoadMapEndpoint,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useRoadContentQuery } = RoadMapService;
export default RoadMapService;
